import React, { FC, useState, createContext, useEffect } from 'react';
import { useMediaQuery } from '@mui/material';
type SidebarContextType = { sidebarToggle: any; toggleSidebar: () => void };

export const SidebarContext = createContext<SidebarContextType>({} as SidebarContextType);

export const SidebarProvider: FC = ({ children }) => {
    const [sidebarToggle, setSidebarToggle] = useState(true);

    const toggleSidebar = () => {
        setSidebarToggle(!sidebarToggle);
    };

    const lgUp = useMediaQuery((theme: any) => theme.breakpoints.up('lg'), {
        defaultMatches: true,
        noSsr: false,
    });

    useEffect(() => {
        setSidebarToggle(lgUp);
    }, [lgUp]);
    return (
        <SidebarContext.Provider value={{ sidebarToggle, toggleSidebar }}>
            {children}
        </SidebarContext.Provider>
    );
};
